import { render, staticRenderFns } from "./ItemsFilters.vue?vue&type=template&id=b0bc3e78"
import script from "./ItemsFilters.vue?vue&type=script&lang=js"
export * from "./ItemsFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports